import React from 'react';
import Episodes from '../pages/Episodes';
import EpisodeDetail from '../pages/EpisodeDetail';
import Blog from '../pages/Blog';
import BlogDetail from '../pages/BlogDetail';
import AboutPage from '../pages/AboutPage';
import DonationPage from '../pages/DonationPage';
import TechPage from '../pages/TechPage';
import TechDetail from '../pages/TechDetail';
import Merch from '../pages/Merch';
import ProductDetail from '../pages/ProductDetail';
import CartPage from '../pages/CartPage';
import CheckoutPage from '../pages/CheckoutPage';
import Advertise from '../pages/Advertise';
import Directory from '../pages/Directory';
import DirectoryCheckoutPage from '../pages/DirectoryCheckoutPage';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import TermsOfService from '../pages/legal/TermsOfService';
import ReturnPolicy from '../pages/legal/ReturnPolicy';
import SignInPage from '../pages/frontend_guhso/SignInPage';
import RegistrationPage from '../pages/frontend_guhso/RegistrationPage';
import MembershipCheckoutPage from '../pages/frontend_guhso/MembershipCheckoutPage';
import SignOutPage from '../pages/frontend_guhso/SignOutPage';
import ProfileDashboardPage from '../pages/frontend_guhso/ProfileDashboardPage';
import HomeTemplate from '../components/templates/HomeTemplate';

export const routes = [
  { path: '/', element: <HomeTemplate /> },
  { path: '/episodes', element: <Episodes /> },
  { path: '/episode/:slug', element: <EpisodeDetail /> },
  { path: '/blog', element: <Blog /> },
  { path: '/blog/:slug', element: <BlogDetail /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/donation', element: <DonationPage /> },
  { path: '/tech', element: <TechPage /> },
  { path: '/tech/:slug', element: <TechDetail /> },
  { path: '/merch', element: <Merch /> },
  { path: '/merch/:slug', element: <ProductDetail /> },
  { path: '/cart', element: <CartPage /> },
  { path: '/checkout', element: <CheckoutPage /> },
  { path: '/advertise', element: <Advertise /> },
  { path: '/directory', element: <Directory /> },
  { path: '/advertise/checkout', element: <DirectoryCheckoutPage /> },
  { path: '/privacy', element: <PrivacyPolicy /> },
  { path: '/terms', element: <TermsOfService /> },
  { path: '/returns', element: <ReturnPolicy /> },
  { path: '/signin', element: <SignInPage /> },
  { path: '/register', element: <RegistrationPage /> },
  { path: '/membership/checkout', element: <MembershipCheckoutPage /> },
  { path: '/signout', element: <SignOutPage /> },
  { path: '/profile', element: <ProfileDashboardPage /> }
];

export const fallbackRoute = {
  path: '*',
  element: (
    <div
      style={{
        textAlign: 'center',
        padding: '4rem 2rem',
        color: 'var(--color-text-muted)'
      }}
    >
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <a href="/" style={{ color: 'var(--color-primary)', fontWeight: 600 }}>
        Go back home
      </a>
    </div>
  )
};
